import slice from './Authorization.slice';

export const { fetchLogout, fetchCheckAuthorization, setAuthorizationStatus } = slice.actions;